/**

* @extends com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler
* @constructor
*/
com.inq.flash.client.control.messagehandlers.CMSDKAutomatonDataMessageHandler = function() {
	this.constructor.__super__.call(this, com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_DATA);
};

$hxClasses.extend(com.inq.flash.client.control.messagehandlers.ClientApplicationMessageHandler,com.inq.flash.client.control.messagehandlers.CMSDKAutomatonDataMessageHandler,"com.inq.flash.client.control.messagehandlers.CMSDKAutomatonDataMessageHandler");

com.inq.flash.client.control.messagehandlers.CMSDKAutomatonDataMessageHandler.prototype.processMessage = function(message) {
	message.setMessageType(com.inq.flash.client.data.MessageFields.TYPE_CHAT_AUTOMATON_DATA);
	this.controller.onNewChatRouterMessage(message);
};